import { Type } from '@angular/core';

/**
 * A dynamic component that is able to open a modal and implement a custom
 * component as the actual modal and allows the passing of possbile data
 * like the needed parameters for POST commands
 *
 * Taken from example: https://angular.io/guide/dynamic-component-loader
 *
 * @author Patrick van Zadel
 */
export class ModalWrapperComponent {
  constructor(
    public component: Type<any>,
    public data: any
  ) {}
}
